import React from 'react';
import gambar1 from '../images/logo.png'

const Footer = () => {
  return (
    <div className="container mx-auto mt-8 px-8">
  <div className="w-full flex flex-col md:flex-row py-6">
    <div className="flex-1 mb-6">
      <a className="text-orange-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl" href="#">
        <img className="w-full" src={gambar1} alt="" />
        <span className="mt-2 inline-block mr-2 md:block md:mr-0">
          <p className="font-light no-underline text-gray-800 text-sm">Sekolah Megana adalah institusi pendidikan yang menyediakan 2 jenis pendidikan berkualitas untuk membantu Orangtua &amp; Siswa SMP dan SMA untuk mencapai prestasi terbaik.</p>
        </span>
      </a>
    </div>
    <div className="flex-1" />
    <div className="flex-1">
      <p className="uppercase font-extrabold text-gray-500 md:mb-6">Alamat</p>
      <ul className="list-reset mb-6">
        <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-light no-underline text-gray-800">Rumah Megana, Jl. Kebon Bawang VI No 35, Tanjung Priok, Jakarta Utara, DKI Jakarta</a>
        </li>
        <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-light no-underline text-gray-800">Liverpool Academy, Pengasinan, Kec. Sawangan, Kota Depok, Jawa Barat 16518</a>
        </li>
        <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-light no-underline text-gray-800">Kelapa Gading, Ruko Inkopal Blok B No 9 (seberang Mall of Indonesia)</a>
        </li>
        {/* <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-light no-underline text-gray-800">Sarinah Building, Lt. 12, <strong className="font-semibold">Jakarta Pusat</strong></a>
        </li> */}
      </ul>
    </div>
    <div className="flex-1" />
    <div className="flex-1">
      <p className="uppercase font-extrabold text-gray-500 md:mb-6">Telepon &amp; Email</p>
      <ul className="list-reset mb-6">
        <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-medium no-underline text-gray-800">+62 822 1103 9755</a>
        </li>
        <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-medium no-underline text-gray-800">+62-21 2243 6830</a>
        </li>
        <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-medium no-underline text-gray-800">sekolahvirtualmegana@gmail.com</a>
        </li>
        <li className="mt-2 inline-block mr-2 md:block md:mr-0">
          <a className="font-medium no-underline text-gray-800">mercysmartacademy@gmail.com</a>
        </li>
      </ul>
    </div>
  </div>
</div>

  );
};

export default Footer;
